// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import ResponsiveImage from '../../internal/ResponsiveImage';
import TextAndMedia, {
  type ImagePropTypes,
  type TextAndMediaPropTypes,
} from '../../internal/TextAndMedia';

type PropTypes = {|
  ...TextAndMediaPropTypes,
  ...ImagePropTypes,
|};

const Image = (props: ImagePropTypes) => (
  <ResponsiveImage
    className={styles.image}
    src={props.image}
    alt={props.alt}
    defaultSize={{ width: 512 }}
    srcSet={[
      { mediaMaxWidth: 767, width: 703 },
      { mediaMaxWidth: 600, width: 536 },
      { mediaMaxWidth: 400, width: 338 },
    ]}
  />
);

const TextAndImage = (props: PropTypes) => {
  return (
    <TextAndMedia
      background={props.background}
      position={props.position}
      intro={props.intro}
      title={props.title}
      media={<Image image={props.image} alt={props.alt} />}
      content={props.content}
    />
  );
};

TextAndImage.defaultProps = {
  position: 'Left',
  background: 'Low',
};

export default TextAndImage;
